<template>
  <div v-html="text" class="default_tpl" />
</template>
<style scoped>
.default_tpl {
  white-space: break-spaces;
}
</style>
<script>
import cloneDeep from "lodash/cloneDeep";
export default {
  props: {
    content: { type: String, required: true },
    append: { type: String }
  },
  data() {
    return {
      text: ""
    };
  },
  created() {
    if (this.content === "Sì") {
      return;
    }
    // es.: numero di porzioni
    if (this.append) {
      let appendString = isNaN(parseInt(this.content))
        ? this.content
        : parseInt(this.content);
      this.text = this.$tc(this.append, appendString);
    } else {
      this.text = cloneDeep(this.content);
    }
  }
};
</script>
